import { render } from "./LayoutAuthentication.vue?vue&type=template&id=b5f0c224&scoped=true"
import script from "./LayoutAuthentication.vue?vue&type=script&lang=ts"
export * from "./LayoutAuthentication.vue?vue&type=script&lang=ts"

import "./LayoutAuthentication.vue?vue&type=style&index=0&id=b5f0c224&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-b5f0c224"

export default script